/*
    Autohandler for the model edit page.
    Should be a view-builder, but a lot of the JS has already been written in the template for the page itself
    When we start adding more functionality to that page we should consider making a view
    TODO incorporate these listeners in the model edit views
 */

var $ = require('./../sw-jquery');
var sw = require('js/lib/sw');
var modelActionCreators = require('js/lib/actions/ModelEdit/actionCreators');

//Todo delete this once the old model-edit experience is removed

$(function() {

    var doneTypingTimeout;
    /*
        This event handler is for the model category dropdown,
        when a user finishes typing we want to submit the form to save the edited category
        doneTypingTimeout is the timeout that actually submits the form
     */
    $('body').on('change keyup', '[data-sw-model-edit-category]' ,function(e) {
        var selectOptionText= $(".modelEditSelect option:selected").text();
        if(e.type === 'keyup'){
            clearTimeout(doneTypingTimeout);
            doneTypingTimeout= setTimeout(function(){ $('[data-sw-model-edit-category]').submit(); }, 500);
        }
        else if(selectOptionText.indexOf("Other")){
            $(this).closest('form').trigger('submit');
        }
    });

    /*
    This function grabs the text from the edited model edit h2 element and assigns it as the value attribute for an input element.
    This is needed to make sure we are sending off the value in the field, since header elements dont have name/value attributes.
    TODO remove form logic since we're not submitting the form, but using an ajax call instead.
    */
    function submitModelTitleForm(form) {
        var newTitle = form.find('[data-sw-model-edit-title]').text();
        sw.dispatch(modelActionCreators.modelTitleChanged(newTitle));
        var data = {
            title: newTitle,
            modelId: form.find('[name="modelId"]').val()
        };
        $.ajax({
            type: 'POST',
            url: '/model/edit/title',
            data: data,
            dataType: 'json',
            success: function (response) {
                sw.notifications.success(response.message);
            }
        });
    }

    /*
        This event handler is for the model title,
        when a user presses enter we want to prevent the default and submit the form.
        The default in this case would be entering a new line.
     */
    var maxAlreadyReached = false;
    $('body').on('keydown', '[data-sw-model-edit-title-form]' ,function(e){
        var editableContent = $('[ data-sw-content-editable-target]');
        var arrowKey = e.which >= 37 && e.which <= 40;
        var deleteKey = e.which === 8;
        if(e.which === 13){
            e.preventDefault();
            //Removing contenteditable triggers focus out, so we let the event handler below handle the request
            editableContent.attr("contenteditable", "false");
        }
        //Check if the key pressed is not the deleteKey, an arrowKey, and the text is over 50 characters long.
        else if(!deleteKey && !arrowKey && editableContent.text().length > 50) {
            e.preventDefault();
            if(!maxAlreadyReached) {
              sw.notifications.error("Exceeded maximum number of characters ");
              maxAlreadyReached = true;
            }
        }
        else if(deleteKey) {
            maxAlreadyReached = false;
        }
    });

    $('body').on('focusout','[data-sw-model-edit-title]' , function(){
        var form = $('[data-sw-model-edit-title-form]');
        $('[data-sw-model-edit-title-form-wrapper]').removeClass('sw-model-edit-title-form__wrapper--contenteditable-triggered');
        if(form.find("[name='title']").val() !== $('[data-sw-model-edit-title]').text()){
            submitModelTitleForm(form);
        }
    });

});
